var agi = agi || {};
agi.expressions = agi.expressions || {};

(function(Event) {
    "use strict";
    var ExpressEvent = function ExpressEvent(type, bubbles, cancelable, data) {
        this.initialize(type, bubbles, cancelable, data);
    };

    var p = ExpressEvent.prototype = new Event();

    p.data = {};

    p.Event_initialize = p.initialize;

    p.initialize = function(type, bubbles, cancelable, data) {
        this.Event_initialize(type, bubbles, cancelable, data);
        this.data = data;
    };

    p.clone = function() {
        return new ExpressEvent(this.type, this.bubbles, this.cancelable,
            this.data);
    };

    p.toString = function() {
        return "[ExpressEvent (type="+this.type+" data="+this.data+")]";
    };

    agi.expressions.ExpressEvent = ExpressEvent;

}(createjs.Event));
